const PREFIX = 'ERRORS_';

export const CLEAR_DEVICE_SEARCH_STATE = `${PREFIX}CLEAR_DEVICE_SEARCH_STATE`;
export const CLEAR_ORG_SEARCH_STATE = `${PREFIX}CLEAR_ORG_SEARCH_STATE`;

export const THROW_DEVICE_ERROR = `${PREFIX}THROW_DEVICE_ERROR`;
export const THROW_ORG_ERROR = `${PREFIX}THROW_ORG_ERROR`;
export const THROW_POSTPAY_ERROR = `${PREFIX}THROW_POSTPAY_ERROR`;
